import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_LINK } from "@/lib/scroll";

export default function WhatsAppFloat() {
    return (
        <motion.a
            data-testid="whatsapp-float-btn"
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 2.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="fixed bottom-6 right-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-[#050B14] shadow-[0_0_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110"
        >
            <MessageCircle size={26} />
        </motion.a>
    );
}
